module.exports = __webpack_public_path__ + "img/indexBackGroupImage1.f31c22d3.png";